import { clsx } from 'clsx'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const SIZE_CLASSES = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-4',
  lg: 'h-12 w-12 border-4',
} as const

export function LoadingSpinner({ size = 'md', className }: LoadingSpinnerProps): React.JSX.Element {
  return (
    <div className={clsx('flex items-center justify-center', className)}>
      <div
        className={clsx(
          'animate-spin rounded-full border-admin-500 border-t-transparent',
          SIZE_CLASSES[size],
        )}
      />
    </div>
  )
}

interface LoadingPageProps {
  message?: string
}

export function LoadingPage({ message }: LoadingPageProps): React.JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center py-24">
      <LoadingSpinner size="lg" />
      {message && <p className="mt-4 text-sm text-text-secondary">{message}</p>}
    </div>
  )
}
